import { render, staticRenderFns } from "./addCount.vue?vue&type=template&id=622ba3f0&scoped=true"
import script from "./addCount.vue?vue&type=script&lang=js"
export * from "./addCount.vue?vue&type=script&lang=js"
import style0 from "./addCount.vue?vue&type=style&index=0&id=622ba3f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ba3f0",
  null
  
)

export default component.exports